import React from "react";

export default function StreamingDeactivatedByPilot({ containerClassName = "videoStreamingContainer" }) {
    return (
        <div className={`${containerClassName} streamingDeactivatedByPilot`}>
            <span>Streaming deactivate by pilot</span>
        </div>
    );
}
